import { RefObject, useEffect, useState } from 'react'

/**
 * True once `ref` gets within `rootMargin` of the viewport (never flips back).
 * Lets below-the-fold videos defer their download until the user approaches.
 */
const useNearViewport = (ref: RefObject<Element>, rootMargin = '300px') => {
  const [near, setNear] = useState(false)

  useEffect(() => {
    const element = ref.current
    if (!element || near) return undefined
    if (typeof IntersectionObserver === 'undefined') {
      setNear(true)
      return undefined
    }
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setNear(true)
          observer.disconnect()
        }
      },
      { rootMargin }
    )
    observer.observe(element)
    return () => observer.disconnect()
  }, [ref, rootMargin, near])

  return near
}

export default useNearViewport
